export enum DialogResult {
    CLOSE = 'close',
    INVESTIGATE = 'investigate'
}
